import styled from 'styled-components'
import { ThemeUIStyleObject } from '@theme-ui/css'
import { Icon, theme } from '@dasa-health/components-react'

export const Container = styled.div`
    width: 100vw;
    padding: 2rem 1rem 2rem 1rem;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        margin: 3.0625rem auto 4rem;
        max-width: calc(100vw - 150px);
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        margin: 2.5rem auto 4rem;
        max-width: 54.5rem;
    }
`

export const StylizedParagraphs = {
    fontWeight: '400',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
} as const

export const CustomIcon = styled(Icon)`
    &&& {
        padding: 0;
        margin: 0.125rem 0.5625rem auto 0;
        font-weight: 700;
    }
`

export const FlexLinksContainer: ThemeUIStyleObject = {
    flexDirection: ['column', 'row'],
    flexWrap: 'wrap',
    m: ['0.625rem 0 3.125rem 0'],
    maxWidth: ['auto', '31rem'],
    'div:first-child': {
        width: ['auto', '8rem'],
    },
    'div:nth-child(2)': {
        width: ['auto', '11.25rem'],
        marginRight: ' 1.375rem',
    },
}

export const LinksContainer = styled.div`
    display: flex;
    flex-direction: column;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 10rem;
    }
`

export const FlexLinksChildren: ThemeUIStyleObject = {
    fontWeight: '400',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    flexBasis: ['100%', '45%'],
    maxWidth: ['8.1875rem', '10rem'],
    whiteSpace: ['nowrap', 'unset'],
}

export const FlexLinksImages: ThemeUIStyleObject = {
    justifyContent: ['flex-start', 'flex-start', 'flex-end'],
    marginRight: ['0', '0', '0'],

    marginLeft: ['0', '0', '33.75rem'],
    marginTop: ['0', '0', '-5.375rem'],
    position: ['unset', 'absolute', 'unset', 'unset'],
}
